import { render, staticRenderFns } from "./spot_type.vue?vue&type=template&id=e2f94b84&"
import script from "./spot_type.vue?vue&type=script&lang=js&"
export * from "./spot_type.vue?vue&type=script&lang=js&"
import style0 from "./spot_type.vue?vue&type=style&index=0&id=e2f94b84&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports